import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { GRIN_DOMAIN } from '../api/consts'

export const GoogleTagManagerProvider = ({ children }) => {
  const gtmParams = { id: 'GTM-N4P5KV' }

  if (document.location.hostname.endsWith(GRIN_DOMAIN)) {
    return <GTMProvider state={gtmParams}>{children}</GTMProvider>
  } else return <>{children}</>
}
